import { render, staticRenderFns } from "./DevDesignColorPalette.vue?vue&type=template&id=5ac1e3ea&scoped=true"
import script from "./DevDesignColorPalette.vue?vue&type=script&lang=js"
export * from "./DevDesignColorPalette.vue?vue&type=script&lang=js"
import style0 from "./DevDesignColorPalette.vue?vue&type=style&index=0&id=5ac1e3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1e3ea",
  null
  
)

export default component.exports